import React, { FC } from 'react';
import { ClockInOutCard } from './ClockInOutCard';
import { ClockProvider } from '../../services/clockIn/ClockService';
import strings from '../../components/clock/clock.translations';
import { useTenantFeatureEnabled } from '../../services/features/TenantFeatureSettingsProvider';

export const ClockInOutPage: FC = () => {
  const clockInEnabled = useTenantFeatureEnabled('clockIn');

  if (!clockInEnabled) {
    return <div className="flex h-screen w-screen justify-center items-center p-8 text-center">{strings.featureDisabled}</div>;
  }

  return (
    <ClockProvider>
      <ClockInOutCard />
    </ClockProvider>
  );
};
